module.exports = __webpack_public_path__ + "static/media/email.f96e9ab1.svg";